//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    src: {
      type: String,
      default: ''
    }
  }
};